import { render, staticRenderFns } from "./DepartmentSetup.vue?vue&type=template&id=9cefc016&"
import script from "./DepartmentSetup.vue?vue&type=script&lang=js&"
export * from "./DepartmentSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports